<template>
    <main>
        <div class="modal fade" id="modalIncapacidades" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Listado de incapacidades, Historia No: {{id_historia}}</h5>
                    <button type="button" class="close"  @click="cerrar();" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card mt-2 shadow-none"  v-if="isLoading">
                        <div class="card-body">
                          <content-placeholders :rounded="true">
                            <content-placeholders-heading :img="false" />
                            <content-placeholders-text :lines="3" />
                          </content-placeholders>
                        </div>
                    </div>
                    <div class="alert alert-warning mt-2" v-else-if="!incapacidades.length">
                        No existen incapacidades...
                    </div>
                    <div v-else class="card mt-2 border-gray-500 shadow-none" v-for="item in incapacidades" :key="item.id">
                        <div class="card-header bg-light">
                            <div class="row">
                                <div class="col-4">
                                    <span class="font-weight-bold">Incapacidad No. {{item.id}}</span>
                                    <span class="badge badge-danger ml-2" v-if="item.es_retroactiva === 'Si'">RETROACTIVA</span>
                                </div>
                                <div class="col-8 d-flex justify-content-end align-items-center">
                                    <span class="text-muted mr-3"><i class="fas fa-user-md mr-1"></i>  <span class="text-danger font-weight-bold">{{item.user.name}}</span> ({{item.created_at | formatDateTime}})</span>
                                    <button @click="imprimir(item.id);" class="btn btn-outline-info lift shadow-sm btn-sm" title="Imprimir">
                                        <i class="fa fa-print fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- Highlighted Clinical Details -->
                            <div class="row mb-3 pb-3 border-bottom border-light">
                                <div class="col-md-9 border-right">
                                    <small class="text-muted d-block font-weight-bold text-uppercase mb-1">Diagnóstico (CIE-10)</small>
                                    <h5 class="font-weight-bold text-dark mb-0" v-if="item.diagnostico">{{item.diagnostico.ID_DIAG}} - {{item.diagnostico.DESC_DIAG}}</h5>
                                    <h5 class="font-weight-bold text-muted mb-0" v-else>N/A</h5>
                                    <p class="text-black-50 mt-2 mb-0" v-if="item.descripcion"><i class="far fa-comment-alt mr-1"></i> {{item.descripcion}}</p>
                                </div>
                                <div class="col-md-3 text-center">
                                    <small class="text-muted d-block font-weight-bold text-uppercase mb-1">Total Días</small>
                                    <h2 class="text-primary font-weight-bolder mb-0">{{item.total_dias}}</h2>
                                    <small class="text-muted font-weight-bold">Desde {{item.fecha_inicial}}<br/>al {{item.fecha_final}}</small>
                                </div>
                            </div>

                            <!-- Logistics Data -->
                            <div class="row mb-2">
                                <div class="col-md-3">
                                    <small class="text-muted d-block">Origen</small>
                                    <span class="font-weight-bold"><i class="fas fa-stethoscope text-secondary mr-1"></i> {{item.origen || 'N/A'}}</span>
                                </div>
                                <div class="col-md-3">
                                    <small class="text-muted d-block">Clase</small>
                                    <span class="font-weight-bold">{{item.clase || 'N/A'}}</span>
                                </div>
                                <div class="col-md-6">
                                    <small class="text-muted d-block">Tipología</small>
                                    <span class="font-weight-bold">{{item.tipo_incapacidad || 'N/A'}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <small class="text-muted d-block">Grupo de servicios</small>
                                    <span class="font-weight-bold"><i class="fas fa-hospital text-secondary mr-1"></i> {{item.grupo_servicios || 'N/A'}}</span>
                                </div>
                                <div class="col-md-6">
                                    <small class="text-muted d-block">Modalidad de la prestación</small>
                                    <span class="font-weight-bold"><i class="fas fa-laptop-medical text-secondary mr-1"></i> {{item.modalidad_prestacion || 'N/A'}}</span>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="item.es_retroactiva === 'Si'">
                                <div class="col-md-12">
                                    <div class="alert alert-danger py-2 mb-0 mt-2 border-0 rounded">
                                        <i class="fas fa-exclamation-triangle mr-1"></i> <strong>Motivo Retroactiva:</strong> {{item.motivo_retroactiva || 'N/A'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light btn-sm" @click="cerrar();"><i class="far fa-times-circle fa-fw"></i> Cerrar</button>
                </div>
                </div>
            </div>
        </div>
        
    </main>
</template>
<script>

import incapacidadService from '../../../../services/incapacidadService';
import $ from "jquery";
export default {
    data(){
        return {
            id_historia:'',
            incapacidades:{},
            isLoading:true
        }
    },
    methods: {
        async  abrir(id){
            this.$nextTick(async () => {
                this.id_historia =id;
                $("#modalIncapacidades").modal("show");
                this.isLoading = true;
                const response = await incapacidadService.showIncapacidadByHc(id);
                this.incapacidades= response.data;
                this.isLoading = false;
            });
        },
        imprimir(id_incapacidad){
            window.open(incapacidadService.print(id_incapacidad));
        },
        cerrar(){
            $("#modalIncapacidades").modal("hide");
            this.incapacidades= {};
        }
    },
}
</script>